export const theme = {
  fontFamily: Styles.fontFamily.body,
};
